// mds-dojo — dijit/form/DataList — FAITHFUL port of references/dijit/form/DataList.js.
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !!! FLAG — declare→native-subclass ADAPTATION (not a stub):
// !!! Real dojo does `declare("dijit.form.DataList", MemoryStore, {...})`. But the canonical
// !!! mds `dojo/store/Memory` is a NATIVE ES class (`export default class Memory`), and the mds
// !!! declare runtime chains base constructors via `ctor.apply(this, …)` — which THROWS
// !!! "Class constructor Memory cannot be invoked without 'new'" for an ES-class base. Since
// !!! DataList is only ever instantiated with `new` (by _AutoCompleterMixin) and is NEVER used
// !!! as a declare([...]) base itself, the faithful mechanism here is a native `class DataList
// !!! extends Memory`. Behavior is preserved exactly: options are read from <option> tags and
// !!! loaded via Memory.setData (real dojo passed them as the {data:…} ctor arg → same effect).
// !!! declaredClass is set on the prototype for parity.
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
import dom from '../../dojo/dom'; // dom.byId
import lang from '../../dojo/_base/lang'; // lang.trim
import query from '../../dojo/query'; // query
import MemoryStore from '../../dojo/store/Memory';
import registry from '../registry'; // registry.add registry.remove

function toItem(/*DOMNode*/ option: any) {
	// summary:
	//		Convert `<option>` node to hash
	return {
		id: option.value,
		value: option.value,
		name: lang.trim(option.innerText || option.textContent || '')
	};
}

// Inefficient but small data store specialized for inlined data via OPTION tags.
class DataList extends MemoryStore {
	domNode: any;
	id: any;

	constructor(params: any, srcNodeRef: any) {
		super();

		// store pointer to original DOM tree
		this.domNode = dom.byId(srcNodeRef);

		lang.mixin(this, params);
		if (this.id) {
			registry.add(this); // add to registry so it can be easily found by id
		}
		this.domNode.style.display = "none";

		// Real dojo passed { data: … } to the Memory ctor; setData is the same load path.
		(this as any).setData(query("option", this.domNode).map(toItem));
	}

	destroy() {
		registry.remove(this.id);
	}

	fetchSelectedItem() {
		// summary:
		//		Get the option marked as selected, like `<option selected>`.
		//		Not part of dojo.data API.
		var option = query("> option[selected]", this.domNode)[0] || query("> option", this.domNode)[0];
		return option && toItem(option);
	}
}

(DataList.prototype as any).declaredClass = "dijit.form.DataList";

export default DataList;
